/**
 * Default PDF Viewer sample
 */
import * as React from "react";
//import "./pdf.component.css";
import {
  Accordion,
  ActionIcon,
  Badge,
  Box,
  Button,
  Center,
  Checkbox,
  Divider,
  Flex,
  Grid,
  Group,
  Indicator,
  Input,
  LoadingOverlay,
  NumberInput,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconFocus2,
  IconGripVertical,
  IconPlus,
  IconRecycle,
  IconSend,
  IconTrash,
} from "@tabler/icons-react";
import { useEffect, useState, useTransition } from "react";
import "./pdf.component.css";

import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { useForm } from "@mantine/form";
import { randomId, useHotkeys, useListState } from "@mantine/hooks";
import { IconX } from "@tabler/icons-react";
import cx from "clsx";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { DelayTime } from "../../_base/helper/FunctionHelper";
import { useStepSignStore } from "../../store";
import { TestModel } from "../../stories/TestModel";
import classes from "./DndListHandle.module.css";

import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import {
  LocalizationMap,
  RenderPage,
  RenderPageProps,
  ScrollMode,
  SpecialZoomLevel,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import { Rnd } from "react-rnd";
import "./Main.css";

import { scrollModePlugin } from "@react-pdf-viewer/scroll-mode";
import { IconEye } from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import {
  convertSignType,
  repositorySign,
  signTypes,
  signTypesModel,
  workerUrl,
} from "../../_base/_const/_constVar";
import { getFileNames, isValidEmail } from "../../_base/extension/Extension";
import {
  SelectListItem,
  SelectListItemBase,
} from "../../_base/model/_base/SelectListItemBase";
import { getRoleSelect, getUsersSelect } from "../../const/getSelectApi";
import {
  findImageAfterDigitalStep,
  signOrderConflictMessage,
} from "../../const/signOrderRule";
import { AddLocationSignModel } from "../../model/AddLocationSignModel";
import { MessageResponse } from "../../model/MessageResponse";
import {
  findDocumentBySignatureId,
  listColor,
  ListStepSign,
  SignaturePage,
} from "../../model/SignPage";
import { TblDocument } from "../../model/TblDocument";
import { PdfFileView } from "./PdfFileView";
import { EcmNodeContent } from "../../model/EcmNodeContent";

type State = {
  x: number;
  y: number;
  width: number;
  height: number;
};
interface PageItem {
  label: string;
  value: string;
  checked: boolean;
  key: number;
}
interface ListValue {
  label: string;
  value: string;
  typecustomer: number | string;
}
function FlowStep2() {
  const [isPending, startTransition] = useTransition();
  // let viewer: PdfViewerComponent | null;
  const [active, setActive] = useState(0);
  const [handlerSelectType, setHandlerSelectType] = useState<Array<ListValue>>(
    []
  );
  const scrollModePluginInstance = scrollModePlugin();
  const [fileNameDownloadV2, setFileNameDownloadV2] = useState<
    EcmNodeContent[]
  >([]);
  // useEffect(() => {
  //   console.log(handlerSelectType);
  //   console.log(formValues.getValues().listStepSign);
  // }, [handlerSelectType]);
  let params = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState<TblDocument>();
  useEffect(() => {
    if (!params.id || Number.parseInt(params.id) < 1) {
      navigate("/method/folders-task");
    } else {
      addLocationSign(Number.parseInt(params.id));
    }
  }, []);

  // Define PageLayout type if not imported
  type PageLayout = {
    transform: (pageIndex: number) => { rotate: number };
    size: ({ height, width }: { height: number; width: number }) => {
      height: number;
      width: number;
    };
    buildPageStyles: () => React.CSSProperties;
  };

  const horizontalLayout: PageLayout = {
    transform: (pageIndex: number) => ({ rotate: 0 }),
    size: ({ height, width }) => ({ height, width }),
    buildPageStyles: () => ({
      margin: "0 8px", // Horizontal margin
      display: "inline-block", // Display inline for horizontal stacking
    }),
  };
  const addLocationSign = async function (id: number) {
    if (document) return;
    setVisible(true);
    try {
    const url = "/api/v1/SignPage/add-location-sign?documentId=" + id;
    const res = await repositorySign.get<MessageResponse<TblDocument>>(url);
    if (res && res.httpStatusCode === 200) {
      if (res.success) {
        const file = res.data?.signedDocument.split("||")[0];
        if (!file) NotificationExtension.Fails("Không tìm được file");
        else {
          const get = file.split("/") ?? "";
          const _file = get[get.length - 1];
          setSelectFile(_file.slice(6));
          setUrlFile(file ?? "");
        }
        if (res.data.signedDocument) {
          const urls = res.data.signedDocument.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }

        setDocument(res.data);
        const url =
          "/api/v1/SampleProcess/get-select-setup-sign?typeDoc=" +
          res.data?.doctypeId;
        const result = await repositorySign.get<
          MessageResponse<SelectListItemBase[]>
        >(url);
        if (result && result.httpStatusCode === 200) {
          if (result.success) {
            await fetchDataEmployee();
            await fetchDataRole();
            setDataSampleProcess(result.data ?? []);
          }
          //   setDisabledBtn(false);
        }
      } else NotificationExtension.Fails(res.message);
    }
    } catch (error) {
      NotificationExtension.Fails("Không tải được dữ liệu tài liệu !");
    } finally {
      setVisible(false);
    }
  };

  const _init: ListStepSign[] = [];

  function resetHalderSelectType() {
    startTransition(() => {
      const _data = formValues.getValues().listStepSign.map((item) => {
        return {
          value: item.key,
          label: item.typesign,
          typecustomer: item.typesigncustomer,
        } as ListValue; // Chuyển kiểu dữ liệu về ListValue
      });
      setHandlerSelectType(_data);
    });
  }
  function resetStep() {
    formValues.setValues({ listStepSign: _init });
    setHandlerSelectType([]);
  }
  const formValues = useForm({
    mode: "uncontrolled",
    validateInputOnChange: false,
    initialValues: {
      listStepSign: _init,
    },
    validate: {
      listStepSign: {
        name: (value) => (value.length < 2 ? "Tên bước chưa nhập" : null),
        email: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "2" && !value) {
            return "Chưa nhập email";
          }
          if (handlerSelectType[index]?.label === "2" && !isValidEmail(value)) {
            return "Email không hợp lệ";
          }
          return null;
        },
        phone: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (handlerSelectType[index]?.label === "3" && !value) {
            return "Chưa nhập số điện thoại !";
          }
          return null;
        },
        username: (value, values, path) => {
          const index = Number(path.split(".")[1]);
          if (
            handlerSelectType[index]?.label === "0" &&
            (!value || value.length < 1)
          ) {
            return "Chưa chọn người xử lý";
          }
          return null;
        },
        typesigncustomer: (value, values, path) => {
          if (!value) return "Chưa chọn công cụ ký !";
          const _val = Number(value);
          if (_val < 0) {
            return "Chưa chọn công cụ ký !";
          }
          return null;
        },

        typesign: (value, values, path) => {
          if (!value || value.length < 1) return "Chưa chọn loại hình ký !";
          return null;
        },
      },
    },
  });
  const _span = { base: 12, lg: 12, xl: 6 };
  const _spanTitle = { base: 12, lg: 12, xl: 6 };
  const [dataSampleProcess, setDataSampleProcess] = useState<
    Array<SelectListItemBase>
  >([]);

  const [valueSelectSampleProcess, setValueSelectSampleProcess] =
    useState<string>();

  function Controls() {
    return (
      <Grid mb={"xs"}>
        <Grid.Col span={_spanTitle}>
          {" "}
          <Title order={6}>Tiêu đề</Title>
          <Input
            value={document?.name}
            disabled
            placeholder="Nhập"
          />
        </Grid.Col>
        <Grid.Col span={_spanTitle}>
          <Title order={6}>Quy trình mẫu</Title>
          <Select
            placeholder="Chọn..."
            data={dataSampleProcess?.map((x) => ({
              label: x.text,
              value: x.value,
            }))}
            searchable
            clearable
            value={valueSelectSampleProcess}
            onChange={(value) => {
              if (value && value.length > 0) {
                setValueSelectSampleProcess(value);
                const getJson = dataSampleProcess.find(
                  (x) => x.value === value
                )?.att1;
                if (getJson) {
                  const _listStep = JSON.parse(getJson) as ListStepSign[];
                  formValues.setValues({ listStepSign: _listStep });
                  const newHandlerSelectType = _listStep.map((element) => ({
                    label: element.typesign,
                    value: element.key,
                    typecustomer: element.typesigncustomer,
                  }));

                  setHandlerSelectType([
                    ...handlerSelectType,
                    ...newHandlerSelectType,
                  ]);
                }
              } else {
                setValueSelectSampleProcess("");
                formValues.setValues({ listStepSign: [] });
                setHandlerSelectType([]);
              }
            }}
          />
        </Grid.Col>
      </Grid>
    );
  }
  // useEffect(() => {
  //   console.log(formValues.getValues().listStepSign);
  // }, [formValues]);
  const [state, handlers] = useListState<TestModel>([]);
  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const [dataListRole, setDataListRole] = useState<SelectListItem[]>([]);

  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListUser(filteredData);
    }
  };
  const fetchDataRole = async () => {
    const dataApi = await getRoleSelect();

    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item: any) => item.text !== null);
      setDataListRole(filteredData);
    }
  };
  const updatePageBySignatureKey = (
    stepKey: string,
    signatureKey: string,
    newPage: number
  ) => {
    setData((prevListStepSign) =>
      prevListStepSign.map((step) => {
        if (step.key === stepKey) {
          return {
            ...step,
            list: step.list.map((signature) =>
              signature.key === signatureKey
                ? { ...signature, page: newPage }
                : signature
            ),
          };
        }
        return step;
      })
    );
  };
  const items = formValues.getValues().listStepSign.map((item, index) => (
    <Draggable key={item.key} index={index} draggableId={item.key}>
      {(provided, snapshot) => (
        <div
          className={cx(classes.item, {
            [classes.itemDragging]: snapshot.isDragging,
          })}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Accordion.Item value={item.key} key={item.key}>
            <Center>
              <Accordion.Control>
                <Flex>
                  <Title order={5}>
                    Bước {index + 1}: {item.name}
                  </Title>
                </Flex>
              </Accordion.Control>

              {Number(handlerSelectType[index]?.typecustomer) > 0 && (
                <>
                  {" "}
                  <Tooltip label="Thêm vị trí">
                    <ActionIcon
                      onClick={() => {
                        //  if (selectType === "Ký ảnh")
                        handleAddStep(
                          item.key,
                          Number.parseInt(
                            handlerSelectType[index]?.typecustomer.toString()
                          ),
                          pageCurrent
                        );
                        //  setSelectType("Ký ảnh");
                      }}
                      size="lg"
                      variant="default"
                      color="gray"
                    >
                      <IconFocus2 color="green" />
                    </ActionIcon>
                  </Tooltip>
                </>
              )}

              <Tooltip label="Thêm bước">
                <ActionIcon
                  onClick={AddStep}
                  ml={"xs"}
                  size="lg"
                  variant="default"
                  color="gray"
                >
                  <IconPlus color="blue" />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xóa bước">
                <ActionIcon
                  onClick={() => {
                    const _index = formValues
                      .getValues()
                      .listStepSign.findIndex((x) => x.key === item.key);
                    //  if (_index >= 0) handlers.remove(_index);
                    if (_index >= 0) {
                      formValues.removeListItem("listStepSign", _index);
                      // setHandlerSelectType(
                      //   handlerSelectType.filter((x) => x.value !== item.key)
                      // );
                      resetHalderSelectType();
                    } else
                      NotificationExtension.Fails(
                        "Không tìm thấy bước để xóa !"
                      );
                  }}
                  ml={"xs"}
                  size="lg"
                  variant="default"
                  color="gray"
                >
                  <IconTrash color="red" />
                </ActionIcon>
              </Tooltip>
              <div {...provided.dragHandleProps} className={classes.dragHandle}>
                <Tooltip label="Di chuyển">
                  <ActionIcon
                    ml={"xs"}
                    size="lg"
                    variant="default"
                    color="gray"
                  >
                    <IconGripVertical
                      style={{ width: rem(28), height: rem(28) }}
                      color="black"
                    />
                  </ActionIcon>
                </Tooltip>
              </div>
            </Center>

            <Accordion.Panel>
              <form
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "end",
                }}
                // onSubmit={(e) => {console.log(e)}}
              >
                <Grid>
                  <Grid.Col span={_span}>
                    {" "}
                    <TextInput
                      withAsterisk
                      label="Tên bước"
                      placeholder="Nhập..."
                      key={formValues.key(`listStepSign.${index}.name`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.name`
                      )}
                    />
                  </Grid.Col>

                  <Grid.Col span={_span}>
                    {" "}
                    <Select
                      // disabled={isPending}
                      label="Loại hình ký: "
                      withAsterisk
                      placeholder="Nhập..."
                      nothingFoundMessage="Không có dữ liệu"
                      data={signTypesModel.map((x) => ({
                        label: x.label,
                        value: x.value.toString(), // Chuyển đổi value sang string
                      }))}
                      searchable
                      clearable
                      {...formValues.getInputProps(
                        `listStepSign.${index}.typesign`
                      )}
                      key={formValues.key(`listStepSign.${index}.typesign`)}
                      onChange={(e) => {
                        startTransition(() => {
                          formValues.setFieldValue(
                            `listStepSign.${index}.typesign`,
                            e
                          );
                          const _sign = e?.toString() ?? "0";
                          setHandlerSelectType((prev) =>
                            prev.map((item, i) =>
                              i === index ? { ...item, label: _sign } : item
                            )
                          );
                        });
                      }}
                    />
                  </Grid.Col>
                  {(handlerSelectType[index]?.label === "0" ||
                    !handlerSelectType[index]) && (
                    <Grid.Col span={_span}>
                      <Select
                        key={formValues.key(`listStepSign.${index}.username`)}
                        label="Người xử lý"
                        withAsterisk
                        placeholder="Chọn..."
                        clearable
                        searchable
                        limit={50}
                        comboboxProps={{
                          transitionProps: {
                            transition: "pop",
                            duration: 200,
                          },
                        }}
                        data={dataListUser.map((item) => {
                          return {
                            label: item.text ?? "",
                            value: String(item.value ?? ""),
                          };
                        })}
                        nothingFoundMessage="Dữ liệu không có !"
                        {...formValues.getInputProps(
                          `listStepSign.${index}.username`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {handlerSelectType[index]?.label === "1" && (
                    <Grid.Col span={_span}>
                      <Select
                        withAsterisk
                        label="Chức danh"
                        placeholder="Nhập..."
                        key={formValues.key(`listStepSign.${index}.roleid`)}
                        searchable
                        clearable
                        limit={50}
                        comboboxProps={{
                          transitionProps: {
                            transition: "pop",
                            duration: 200,
                          },
                        }}
                        data={dataListRole.map((item) => {
                          return {
                            label: item.text,
                            value: String(item.value ?? ""),
                          };
                        })}
                        nothingFoundMessage="Dữ liệu không có !"
                        {...formValues.getInputProps(
                          `listStepSign.${index}.roleid`
                        )}
                      />
                    </Grid.Col>
                  )}

                  {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                    1 && (
                    <Grid.Col span={_span}>
                      <Select
                        label="Đối tác"
                        placeholder="Nhập..."
                        key={formValues.key(`listStepSign.${index}.vendorid`)}
                        searchable
                        clearable
                        {...formValues.getInputProps(
                          `listStepSign.${index}.vendorid`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {(handlerSelectType[index]?.label ?? "0") === "2" && (
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Email"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.email`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.email`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {(handlerSelectType[index]?.label ?? "0") === "3" && (
                    <Grid.Col span={_span}>
                      <TextInput
                        withAsterisk
                        label="Số điện thoại"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.phone`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.phone`
                        )}
                      />
                    </Grid.Col>
                  )}
                  {Number.parseInt(handlerSelectType[index]?.label ?? "0") >
                    1 && (
                    <>
                      {/* <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Ekyc"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.issign`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.issign`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col>
                    <Grid.Col span={_span}>
                      {" "}
                      <TextInput
                        withAsterisk
                        label="Thêm bước"
                        placeholder="Nhập"
                        key={formValues.key(`listStepSign.${index}.addstep`)}
                        {...formValues.getInputProps(
                          `listStepSign.${index}.addstep`,
                          {
                            type: "checkbox",
                          }
                        )}
                      />
                    </Grid.Col> */}
                      <Grid.Col span={_span}>
                        {" "}
                        <TextInput
                          label="Mã số thuế"
                          placeholder="Nhập"
                          key={formValues.key(`listStepSign.${index}.taxcode`)}
                          {...formValues.getInputProps(
                            `listStepSign.${index}.taxcode`
                          )}
                        />
                      </Grid.Col>
                    </>
                  )}

                  <Grid.Col span={_span}>
                    <Select
                      key={formValues.key(
                        `listStepSign.${index}.typesigncustomer`
                      )}
                      withAsterisk
                      label="Công cụ ký: "
                      placeholder="Nhập..."
                      nothingFoundMessage="Không có dữ liệu"
                      //  defaultValue={signTypes[0].value.toString()}
                      data={signTypes.map((x) => ({
                        label: x.label,
                        value: x.value.toString(), // Chuyển đổi value sang string
                      }))}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.typesigncustomer`
                      )}
                      onChange={(e) => {
                        startTransition(() => {
                          formValues.setFieldValue(
                            `listStepSign.${index}.typesigncustomer`,
                            e
                          );
                          const _sign = e?.toString() ?? "0";
                          setHandlerSelectType((prev) =>
                            prev.map((item, i) =>
                              i === index
                                ? {
                                    ...item,
                                    typecustomer: Number.parseInt(_sign),
                                  }
                                : item
                            )
                          );
                        });
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={_span}>
                    {" "}
                    <NumberInput
                      key={formValues.key(`listStepSign.${index}.expdate`)}
                      {...formValues.getInputProps(
                        `listStepSign.${index}.expdate`
                      )}
                      min={0}
                      label="Quá hạn sau(ngày)"
                      placeholder="Nhập"
                    />
                  </Grid.Col>
                </Grid>
              </form>

              <Divider size={"md"} my="lg" variant="dashed" />

              <Group>
                {data
                  .find((xx) => xx.key === item.key)
                  ?.list.map((sign, index) => (
                    <>
                      <Group>
                        <Text>{index + 1}. Chọn trang</Text>
                        <NumberInput
                          size="xs"
                          style={{ width: "55px" }}
                          value={sign.page + 1}
                          onClick={() => {
                            setSelectedItemId(sign.key);
                          }}
                          hideControls
                          onKeyUp={(e) => {
                            const _v = e.currentTarget.value;
                            if (e.key === "Enter") {
                              // Kiểm tra nếu phím Enter được nhấn
                              const value =
                                typeof _v === "string"
                                  ? Number.parseInt(_v)
                                  : (e.target as HTMLInputElement)
                                      .valueAsNumber;
                              const h = value > 0 ? value - 1 : 0;

                              if (typeof h === "number") {
                                if (h < 0) {
                                  NotificationExtension.Fails(
                                    "Số trang phải lớn hơn 0 !"
                                  );
                                  return;
                                }
                                if (h > pageTotal) {
                                  NotificationExtension.Fails(
                                    "Số trang phải nhỏ hơn hơn " +
                                      pageTotal +
                                      " !"
                                  );
                                  return;
                                }
                                updatePageBySignatureKey(item.key, sign.key, h);
                              }

                              jumpToPage(h);
                              //  setDisabledBtn(true);
                              setPageCurrent(h);
                            }
                          }}
                          // onChange={(e) => {
                          //   if (typeof e === "number") {
                          //     if (e < 1) {
                          //       NotificationExtension.Fails(
                          //         "Số trang phải lớn hơn 0 !"
                          //       );
                          //       return;
                          //     }
                          //     if (e > pageTotal) {
                          //       NotificationExtension.Fails(
                          //         "Số trang phải nhỏ hơn hơn " +
                          //           pageTotal +
                          //           " !"
                          //       );
                          //       return;
                          //     }
                          //     updatePageBySignatureKey(
                          //       item.key,
                          //       sign.key,
                          //       e - 1
                          //     );
                          //   }
                          // }}
                        />

                        <ActionIcon
                          size="md"
                          variant="outline"
                          color="red"
                          aria-label="ActionIcon the same size as inputs"
                          onClick={() => {
                            const filteredData = data.map((document) => ({
                              ...document,
                              list: document.list.filter(
                                (signature) => signature.key !== sign.key
                              ),
                            }));
                            setData(filteredData);
                          }}
                        >
                          <IconTrash />
                        </ActionIcon>
                        <Divider size="md" orientation="vertical" />
                      </Group>
                    </>
                  ))}
              </Group>
            </Accordion.Panel>
          </Accordion.Item>
        </div>
      )}
    </Draggable>
  ));

  //
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [userSelect, setUserSelect] = useState<boolean>(false);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  //new sign
  // luc chot thi map lại vào form value
  const [data, setData] = useState<Array<ListStepSign>>([]);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  //
  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {/* // tạm comment lại vì hiển thị dạng sticky, Chiến xác nhận */}
        {/* {props.annotationLayer.children} */}
        {props.textLayer.children}
        {/* type là duyệt thì không cần hiển thị */}
        {data
          .filter((x) => x.typesigncustomer !== 0)
          .map((doc, index) =>
            doc.list
              .filter((signaturePage) => {
                // console.log("File comparison:", signaturePage.files, urlFile);
                // console.log("check:", signaturePage.files === urlFile);
                return (
                  signaturePage.page === props.pageIndex &&
                  signaturePage.files?.toString() === urlFile
                );
              })
              .map((item, indexSign) => {
                const stepIndex = formValues
                  .getValues()
                  .listStepSign.findIndex((xx) => xx.key === doc.key);
                const boxColor =
                  listColor[
                    (stepIndex >= 0 ? stepIndex : index) % listColor.length
                  ] || "#228be6";
                return (
                <Rnd
                  key={item.key}
                  className="signature-step"
                  bounds={boundaryElm}
                  size={{
                    width: item.width,
                    height: item.height,
                  }}
                  position={{
                    x: item.x,
                    y: item.y,
                  }}
                  onDragStop={(e: any, d: any) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) => {
                        //  if (kyPage.page === pageCurrent) {
                        if (true) {
                          return {
                            ...kyPage,
                            ...(kyPage.key === item.key && {
                              x:
                                d.x + kyPage.width > props.width
                                  ? props.width - kyPage.width
                                  : d.x < 0
                                  ? 0
                                  : d.x,
                              y:
                                d.y + kyPage.height > props.height
                                  ? props.height - kyPage.height
                                  : d.y < 0
                                  ? 0
                                  : d.y,
                            }),
                          };
                        }
                        return kyPage;
                      }
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);

                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    const updatedKy: SignaturePage[] = doc.list.map(
                      (kyPage, kyIndex) =>
                        //   kyPage.page === pageIndex + 1
                        true
                          ? {
                              ...kyPage,
                              ...(kyPage.key === item.key && {
                                width: ref.offsetWidth,
                                height: ref.offsetHeight,
                                ...position,
                              }),
                            }
                          : kyPage
                    );
                    const _res = data.map((d) =>
                      d.key === doc.key ? { ...d, list: updatedKy } : d
                    );
                    setData(_res);
                    // setData(
                    //   data.map((d) =>
                    //     d.key === doc.key ? { ...d, list: updatedKy } : d
                    //   )
                    // );
                  }}
                  onClick={() => {
                    //  console.log(props.height,props.width)
                    if (item.key !== selectedItemId) {
                      setSelectedItemId(item.key);
                      var check = findDocumentBySignatureId(
                        data,
                        selectedItemId
                      );
                      if (check && check.page !== pageCurrent) {
                        setPageCurrent(check.page);
                      }

                      const getSignPage = data.find(
                        (x) =>
                          x.list.findIndex((xx) => xx.key === item.key) !== -1
                      );
                      if (getSignPage) {
                        setSelectedLibrary(getSignPage.key);
                      }

                      const getTypeSelect = convertSignType(
                        Number(getSignPage?.typesigncustomer) || -1
                      );
                      setSelectType(getTypeSelect);
                    }
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "8px",
                    justifyContent: "center",
                    border:
                      selectedItemId === item.key
                        ? `solid 3px ${boxColor}`
                        : `solid 1.5px ${boxColor}`,
                    background: `${boxColor}1A`,
                    boxShadow:
                      selectedItemId === item.key
                        ? `0 0 0 3px ${boxColor}33`
                        : "none",
                    color: boxColor,
                    fontWeight: 600,
                    fontSize: "12px",
                    zIndex: 9999,
                  }}
                >
                  <ActionIcon
                    onClick={() => {
                      const filteredData = data.map((document) => ({
                        ...document,
                        list: document.list.filter(
                          (signature) => signature.key !== item.key
                        ),
                      }));
                      setData(filteredData);
                    }}
                    size={"xs"}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                    }}
                    variant="filled"
                    color="red"
                    aria-label="Settings"
                  >
                    <IconX stroke={1.5} />
                  </ActionIcon>{" "}
                  <ActionIcon
                    size={"xs"}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: `${item.width - 12}` + "px",
                    }}
                    variant="filled"
                    //  / color="red"
                    aria-label="Settings"
                  >
                    <Indicator
                      inline
                      label={indexSign + 1}
                      size={16}
                    ></Indicator>
                  </ActionIcon>
                  {/* lay theo tung vi tri, fix tam khong lay theo buoc ky==> parseInt(item?.typesigncustomer?.toString() */}
                  <span
                    style={{
                      maxWidth: "100%",
                      padding: "0 6px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {`Bước ${
                      formValues
                        .getValues()
                        .listStepSign.findIndex((xx) => xx.key === doc.key) + 1
                    }: ${convertSignType(Number(doc.typesigncustomer))}`}
                  </span>
                </Rnd>
                );
              })
          )}
      </>
    );
  };
  const [pageCurrent, setPageCurrent] = useState<number>(-1);
  const [pageTotal, setPageTotal] = useState<number>(1);

  const [stateSign, setStateSign] = useState<State>({
    width: 120,
    height: 70,
    x: 0,
    y: 0,
  });
  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  //
  const [selectedLibrary, setSelectedLibrary] = useState<string | null>(); // Quản lý giá trị Select
  const [selectType, setSelectType] = useState<string>("");
  const [selectFile, setSelectFile] = useState<string>();

  function AddStep() {
    const newDocument: ListStepSign = {
      id: 0,
      key: randomId(),
      username: "",
      email: "",
      numberstep: 1,
      list: [],
      idsetupstepsign: 0,
      name: "",
      typesign: "0",
      typesigncustomer: 0,
      issign: 0,
      filehistorysign: "",
      vendorid: 0,
    };
    formValues.insertListItem("listStepSign", newDocument);
    startTransition(() => {
      setHandlerSelectType([
        {
          label: newDocument.typesign,
          value: newDocument.key,
          typecustomer: newDocument.typesigncustomer,
        },
        ...handlerSelectType,
      ]);
    });
  }

  useHotkeys([
    [
      "ctrl+d",
      () => {
        AddStep();
      },
    ],
  ]);

  const handleAddStep = (
    userNameSelect: string,
    type: number,
    pageNumber: number,
    x: number = stateSign.x,
    y: number = stateSign.y,
    w: number = stateSign.width,
    h: number = stateSign.height
  ) => {
    if (
      !urlFile ||
      urlFile.length < 6 ||
      !document?.signedDocument.split("||").find((x) => x.includes(urlFile)) ||
      selectFile === undefined
    ) {
      NotificationExtension.Fails("Không tìm thấy file !");
      return;
    }
    // pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    const getUserSelect = formValues
      .getValues()
      .listStepSign.find((item) => item.key === userNameSelect);
    if (getUserSelect) {
      const _sign: SignaturePage = {
        key: randomId(),
        x: x,
        y: y,
        width: w,
        height: h,
        page: pageNumber,
        id: 0,
        files: urlFile,
        namefilefrist: selectFile ?? "",
        typesigncustomer: type,
      };
      const existingDocumentIndex = data.findIndex(
        (doc) => doc.key === userNameSelect
      );
      //note: type >0 thì mới tạo vị trí để ký
      // kiểu duyệt không cần update hay thêm gì cả
      if (existingDocumentIndex !== -1) {
        // Nếu đã tồn tại userNameSelect
        const updatedDocuments = data.map((doc, index) => {
          if (index === existingDocumentIndex) {
            const pageIndex = doc.list.findIndex(
              (page) => page.page === pageNumber
            ); // Kiểm tra page 1 đã tồn tại

            if (pageIndex !== -1) {
              let update: Array<SignaturePage> = doc.list;
              if (type > 0)
                doc.list.forEach((signaturePage, idx) => {
                  if (idx === pageIndex) {
                    update.push(_sign);
                    return;
                  }
                });
              const _res: ListStepSign = {
                ...doc,
                // cho update hết về 1 type
                typesigncustomer: type,
                list: type === 0 ? doc.list : update,
              };
              return _res;
            } else {
              const _updated: SignaturePage = {
                page: pageNumber,
                id: _sign.id,
                x: _sign.x,
                y: _sign.y,
                width: _sign.width,
                height: _sign.height,
                key: _sign.key,
                files: _sign.files,
                namefilefrist: _sign.namefilefrist,
              };
              const _res: ListStepSign = {
                ...doc,

                typesigncustomer: type,
                list: type === 0 ? doc.list : [...doc.list, _updated],
              };

              return _res;
            }
          }
          return doc;
        });
        setData(updatedDocuments);
      } else {
        // Nếu chưa tồn tại selectedLibrary, tạo Document mới
        const newDocument: ListStepSign = {
          id: 0,
          key: getUserSelect.key,
          username: getUserSelect.username,
          email: getUserSelect.email ? getUserSelect.email.toLowerCase() : "",
          numberstep: getUserSelect.numberstep,
          list: type === 0 ? [] : [_sign],
          idsetupstepsign: 0,
          name: getUserSelect.name,
          typesign: getUserSelect.typesign,
          typesigncustomer: type,
          issign: 0,
          filehistorysign: "",
          vendorid: 0,
        };
        setData([...data, newDocument]);
      }
    } else {
      NotificationExtension.Info("Bạn chưa chọn người ký !");
      setSelectType("");
    }
  };

  const [initialValues, setInitialValues] = useState<PageItem[]>([]);
  useEffect(() => {
    let init: PageItem[] = [];
    if (pageTotal > 0) {
      for (let index = 0; index < pageTotal; index++) {
        init.push({
          label: "Trang " + (index + 1),
          value: index.toString(),
          checked: false,
          key: index,
        });
      }
      setInitialValues(init);
      handlersCheckbox.setState(init);
    }
  }, [pageTotal]);

  const [values, handlersCheckbox] = useListState(initialValues);

  const allChecked = values.every((value) => value.checked);
  const indeterminate = values.some((value) => value.checked) && !allChecked;
  const itemCheckboxs = values.map((valueCheckbox, index) => (
    <Checkbox
      mt="xs"
      ml={33}
      disabled={selectedItemId == null}
      label={valueCheckbox.label}
      key={valueCheckbox.key}
      checked={valueCheckbox.checked}
      onChange={async (event) => {
        var getListStepSign = data.find(
          (x) => x.list.filter((xx) => xx.key === selectedItemId).length > 0
        );
        var getSign = findDocumentBySignatureId(data, selectedItemId);
        const _page = Number.parseInt(valueCheckbox.value);
        if (getSign && getListStepSign)
          if (event.currentTarget.checked) {
            if (getSign) {
              const _s = getSign;
              handleAddStep(
                getListStepSign.key,
                Number(getListStepSign.typesigncustomer),
                _page,
                _s.x,
                _s.y,
                _s.width,
                _s.height
              );
              handlersCheckbox.setItemProp(index, "checked", true);
            }
          } else {
            const filteredData = data.map((document) => ({
              ...document,
              list: document.list.filter(
                (signature) =>
                  (document.username !== getListStepSign?.username ||
                    signature.page !== _page) &&
                  signature.namefilefrist !== getSign?.namefilefrist
              ),
            }));
            setData(filteredData);
            handlersCheckbox.setItemProp(index, "checked", false);
          }
        else {
          NotificationExtension.Fails("chữ ký bạn chọn đã bị xóa !");
        }
      }}
    />
  ));

  const [resize, SetResize] = useState<any>();

  const [valueTabs, setValueTabs] = useState<string | null>("type");

  const bears = useStepSignStore();
  const [visible, setVisible] = useState(false);

  useHotkeys([
    [
      "Delete",
      () => {
        const filteredData = data.map((document) => ({
          ...document,
          list: document.list.filter(
            (signature) => signature.key !== selectedItemId
          ),
        }));
        setData(filteredData);
      },
    ],
  ]);
  const [stateColor, setStateColor] = useState<string>(listColor[0]);
  useEffect(() => {
    setStateColor(listColor[Number.parseInt(selectedLibrary ?? "0")]);
  }, [selectedLibrary]);

  //new

  const [urlFile, setUrlFile] = useState<string>("");

  /**
   * Hàm chuyển đổi giá trị số thành chuỗi tương ứng
   * @param value Giá trị đầu vào dạng số
   * @returns Chuỗi tương ứng với giá trị số đầu vào
   */

  const _gridType = { base: 6, md: 6, lg: 6, xl: 3 };

  // const [disabledBtn, setDisabledBtn] = useState(false);
  // useEffect(() => {
  //   if (disabledBtn) setDisabledBtn(false);
  // }, [pageCurrent]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  return (
    <>
      {document && (
        <Box pos="relative">
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 2 }}
          />
          <div
            style={{
              // float: "inline-end",
              // position: "absolute",
              // bottom: "-20px",
              // right: 0,
              // width: "100%",
              // background: "white",
              marginBottom: "10px",
              zIndex: 999,
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "16px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Group gap="sm">
              <Box
                px="md"
                py={6}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  background: "#f8fafc",
                  minWidth: 120,
                }}
              >
                <Text size="lg" fw={700} c="blue.7" lh={1.1}>
                  {formValues.getValues().listStepSign.length}
                </Text>
                <Text size="xs" c="dimmed">
                  Tổng số bước ký
                </Text>
              </Box>
              <Box
                px="md"
                py={6}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  background: "#f8fafc",
                  minWidth: 120,
                }}
              >
                <Text size="lg" fw={700} c="teal.7" lh={1.1}>
                  {data.reduce((sum, item) => sum + item.list.length, 0)}
                </Text>
                <Text size="xs" c="dimmed">
                  Tổng số chữ ký
                </Text>
              </Box>
              <Box
                px="md"
                py={6}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  background: "#f8fafc",
                  minWidth: 120,
                }}
              >
                <Text size="lg" fw={700} c="gray.7" lh={1.1}>
                  {
                    formValues
                      .getValues()
                      .listStepSign.filter((x) => x.typesigncustomer === 0)
                      .length
                  }
                </Text>
                <Text size="xs" c="dimmed">
                  Bước phê duyệt
                </Text>
              </Box>
            </Group>
            <Group>
              <Button
                size="xs"
                onClick={async () => {
                  if (
                    !document.attachments ||
                    document.attachments.length === 0
                  ) {
                    NotificationExtension.Info("Không có file đính kèm");
                    return;
                  }

                  modals.openConfirmModal({
                    title: <Title order={4}>Xem file đính kèm</Title>,
                    size: "80%",
                    radius: "md",
                    children: <PdfFileView file={document.attachments} />,
                    confirmProps: { display: "none" },
                    cancelProps: { display: "none" },
                  });
                }}
                leftSection={<IconEye />}
                variant="light"
                color="blue"
                disabled={
                  !document.attachments || document.attachments.length === 0
                }
              >
                Xem file đính kèm
              </Button>
              <Button
                size="xs"
                onClick={() => {
                  AddStep();
                }}
                leftSection={<IconPlus />}
                variant="light"
              >
                Thêm bước (Ctrl+D)
              </Button>

              <Button
                size="xs"
                onClick={() => {
                  resetStep();
                }}
                leftSection={<IconRecycle />}
                variant="subtle"
                color="gray"
              >
                Làm lại
              </Button>

              <Button
                size="xs"
                disabled={disabledBtn}
                color="blue"
                rightSection={<IconSend />}
                onClick={async () => {
                  if (formValues.validate().hasErrors) {
                    NotificationExtension.Fails(
                      "Vui lòng điền đầy đủ thông tin !"
                    );
                    return;
                  }

                  if (
                    formValues.isValid() &&
                    formValues.getValues().listStepSign &&
                    formValues.getValues().listStepSign.length > 0
                  ) {
                    setDisabledBtn(true);
                    let entity: AddLocationSignModel = {
                      sampId: 0,
                      setupstepsign: {
                        id: 0,
                        documentId: document.id,
                        title: document.name,
                        fileUrl: "",
                        createBy: "",
                        lastUpdateBy: "",
                        list: [],
                        sampleprocessid: Number.parseInt(
                          valueSelectSampleProcess ?? "0"
                        ),
                      },
                      listStepSignModels: [],
                    };
                    if (
                      valueSelectSampleProcess &&
                      valueSelectSampleProcess.length > 0
                    ) {
                      entity.sampId = Number.parseInt(valueSelectSampleProcess);
                    }
                    let isValidate = true;
                    formValues.getValues().listStepSign.forEach((x, index) => {
                      // duyệt chưa thêm vào mảng, tiến hành thêm vào
                      if (x.typesigncustomer.toString() === "0") {
                        entity.listStepSignModels.push({
                          listStepsign: { ...x, numberstep: index + 1 },
                          signaturePages: x.list,
                        });
                      } else {
                        const _getListStep = data.find((y) => y.key === x.key);
                        if (_getListStep) {
                          entity.listStepSignModels.push({
                            listStepsign: { ...x, numberstep: index + 1 },
                            signaturePages: _getListStep.list,
                          });
                        } else {
                          NotificationExtension.Fails(
                            `Bước ký ${index + 1} chưa thêm vị trí ký !`
                          );
                          isValidate = false;
                          return 1;
                        }
                      }
                    });
                    //     debugger;

                    const signOrderConflict = findImageAfterDigitalStep(
                      entity.listStepSignModels.map((x) => ({
                        name: x.listStepsign.name,
                        typesigncustomer: Number(x.listStepsign.typesigncustomer),
                        files: (x.signaturePages ?? [])
                          .map((p) => p.files?.toString())
                          .filter((f): f is string => !!f),
                      }))
                    );
                    if (isValidate && signOrderConflict) {
                      NotificationExtension.Fails(
                        signOrderConflictMessage(signOrderConflict)
                      );
                      isValidate = false;
                    }

                    if (isValidate) {
                      setVisible(true);
                      const url = "/api/v1/SignPage/add-location-sign";
                      await DelayTime(500);
                      const result = await repositorySign.post<
                        MessageResponse<boolean>
                      >(url, entity);
                      if (result && result.httpStatusCode === 200) {
                        if (result.success) {
                          NotificationExtension.Success("Thành công !");
                          setTimeout(() => {
                            navigate("/method/approve-task");
                          }, 2000);
                        } else
                          NotificationExtension.Fails(
                            result.message.length > 0
                              ? result.message
                              : "Thất bại !"
                          );
                        //   setDisabledBtn(false);
                      }
                    }
                  }

                  setVisible(false);
                  setDisabledBtn(false);
                }}
                variant="filled"
              >
                Trình ký
              </Button>
              <Button
                variant="subtle"
                color="gray"
                size="xs"
                rightSection={<IconX />}
                onClick={() => {
                  navigate("/method/folders-task");
                }}
              >
                Đóng
              </Button>
            </Group>
          </div>
          <div
            style={{
              position: "relative",
              height: "calc(100vh - 250px)",
            }}
          >
            <Grid>
              <Grid.Col span={{ base: 12, md: 7, lg: 7, xl: 8 }}>
                <Flex
                  align={"center"}
                  mb={"10px"}
                  w={"100%"}
                  gap={"xs"}
                  justify={"space-between"}
                >
                  <Flex align={"center"} gap={"xs"}>
                    <strong>Chọn tài liệu</strong>
                    <Select
                      ml={"10px"}
                      label=""
                      placeholder="Chọn..."
                      value={selectFile}
                      onChange={(e) => {
                        const _key = e ?? "";
                        setSelectFile(_key);
                        if (_key.length > 0) {
                          const file = document.signedDocument
                            .split("||")
                            .find((x) => x.includes(_key));
                          if (file) setUrlFile(file);
                          //  setDisabledBtn(t                                        rue);
                          setPageCurrent(-1);
                          setSelectedItemId("");
                        }
                      }}
                      data={document.signedDocument.split("||").map((x) => ({
                        label:
                          fileNameDownloadV2.find(
                            (file) => file.fileName === x.split("/").pop()
                          )?.originName ?? x.split("/").pop() ?? "",
                        value: x.split("/")[x.split("/").length - 1].slice(6),
                      }))}
                    />
                  </Flex>
                </Flex>{" "}
                <div
                  className="rpv-core__viewer"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    border: "1px solid #e5e7eb",
                    borderRadius: 8,
                    background: "#f8f9fa",
                  }}
                >
                  {/* <div
                    style={{
                      alignItems: "center",
                      backgroundColor: "#fff",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                      display: "flex",
                      justifyContent: "center",
                      padding: "4px",
                    }}
                  >
                    <div style={{ padding: "0 2px" }}>
                      <GoToFirstPage>
                        {(props: RenderGoToPageProps) => (
                          <ActionIcon
                            onClick={() => {
                              //  setDisabledBtn(true);
                              props.onClick();
                            }}
                            variant="filled"
                            aria-label="Settings"
                          >
                            <IconPlayerTrackPrevFilled
                              style={{
                                width: "70%",
                                height: "70%",
                              }}
                              stroke={1.5}
                            />
                          </ActionIcon>
                        )}
                      </GoToFirstPage>
                    </div>
                    <div style={{ padding: "0 2px" }}>
                      <GoToPreviousPage>
                        {(props: RenderGoToPageProps) => (
                          <ActionIcon
                            disabled={props.isDisabled}
                            onClick={() => {
                              //  setDisabledBtn(true);
                              props.onClick();
                            }}
                            variant="filled"
                            aria-label="Settings"
                          >
                            <IconCaretLeftFilled
                              style={{
                                width: "70%",
                                height: "70%",
                              }}
                              stroke={1.5}
                            />
                          </ActionIcon>
                        )}
                      </GoToPreviousPage>
                    </div>
                    <div
                      style={{
                        width: "100px",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <NumberInput
                        style={{
                          width: "50px",
                        }}
                        key="currentPage"
                        id="currentPage"
                        size="xs"
                        value={pageCurrent + 1}
                        hideControls
                        onKeyUp={(e) => {
                          const _v = e.currentTarget.value;
                          if (e.key === "Enter") {
                            // Kiểm tra nếu phím Enter được nhấn
                            const value =
                              typeof _v === "string"
                                ? Number.parseInt(_v)
                                : (e.target as HTMLInputElement).valueAsNumber;
                            const h = value > 0 ? value - 1 : 0;
                            jumpToPage(h);
                            //  setDisabledBtn(true);
                            setPageCurrent(h);
                          }
                        }}
                        min={1}
                        max={pageTotal}
                      />{" "}
                      <strong>/{pageTotal}</strong>
                      <CurrentPageLabel>
                            {(props: RenderCurrentPageLabelProps) => (
                              <>{props && <></>}</>
                            )}
                          </CurrentPageLabel>
                    </div>

                    <div style={{ padding: "0 2px" }}>
                      <GoToNextPage>
                        {(props: RenderGoToPageProps) => (
                          <ActionIcon
                            disabled={props.isDisabled}
                            onClick={() => {
                              //     setDisabledBtn(true);
                              props.onClick();
                            }}
                            variant="filled"
                            aria-label="Settings"
                          >
                            <IconCaretRightFilled
                              style={{
                                width: "70%",
                                height: "70%",
                              }}
                              stroke={1.5}
                            />
                          </ActionIcon>
                        )}
                      </GoToNextPage>
                    </div>
                    <div style={{ padding: "0 2px" }}>
                      <GoToLastPage>
                        {(props: RenderGoToPageProps) => (
                          <ActionIcon
                            onClick={() => {
                              //   setDisabledBtn(true);
                              props.onClick();
                            }}
                            variant="filled"
                            aria-label="Settings"
                          >
                            <IconPlayerTrackNextFilled
                              style={{
                                width: "70%",
                                height: "70%",
                              }}
                              stroke={1.5}
                            />
                          </ActionIcon>
                        )}
                      </GoToLastPage>11
                    </div>
                  </div> */}
                  <div className="App" ref={(ref) => setBoundaryElm(ref!)}>
                    <Worker workerUrl={workerUrl}>
                      <Viewer
                        localization={de_DE as unknown as LocalizationMap}
                        fileUrl={urlFile}
                        plugins={[
                          defaultLayoutPluginInstance,
                          pageNavigationPluginInstance,
                        ]}
                        scrollMode={ScrollMode.Vertical}
                        pageLayout={horizontalLayout}
                        defaultScale={SpecialZoomLevel.ActualSize}
                        renderPage={renderPage}
                        onPageChange={(e) => {
                          if (pageTotal !== e.doc.numPages)
                            setPageTotal(e.doc.numPages);
                          setPageCurrent(e.currentPage);
                        }}
                      />
                    </Worker>
                  </div>
                </div>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 5, lg: 5, xl: 4 }}>
                {/* Sticky Controls */}
                <div
                  style={{
                    // position: "sticky",
                    // top: 60,
                    // zIndex: 2,
                    background: "white",
                    paddingBottom: 8,
                    paddingTop: 8,
                    paddingLeft: 8,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                  }}
                >
                  {Controls()}
                </div>
                {/* Scrollable DragDropContext */}
                <div
                  style={{
                    overflowY: "auto",
                    position: "relative",
                    maxHeight: "60vh", // hoặc dùng 400px, 500px tùy ý
                    minHeight: 300,
                  }}
                >
                  <DragDropContext
                    onDragEnd={({ destination, source }) => {
                      if (destination?.index !== undefined) {
                        formValues.reorderListItem("listStepSign", {
                          from: source.index,
                          to: destination.index,
                        });
                        resetHalderSelectType();
                      }
                    }}
                  >
                    <Droppable droppableId="dnd-list" direction="vertical">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          <Accordion
                            chevronPosition="right"
                            variant="contained"
                            multiple={true}
                          >
                            {items}
                          </Accordion>
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Grid.Col>
            </Grid>
          </div>
        </Box>
      )}
      {!document && <>Tài liệu không tồn tại !</>}
    </>
  );
}

export default FlowStep2;
